import PropTypes from 'prop-types'

import Body from './body'
import Header from './header'
import Breadcrumb from './breadcrumb'

const Detail = ({ article, ...attrs }) => {
  return <>
    <Header
      article={article} />
    <Body
      article={article} />
    <Breadcrumb
      article={article} />
  </>
}

Detail.propTypes = {
  article: PropTypes.object
}

export default Detail
